
// ── Scroll reveal ──
const o=new IntersectionObserver(e=>e.forEach(x=>{if(x.isIntersecting)x.target.classList.add('on')}),{threshold:.1});
document.querySelectorAll('.rv').forEach(e=>o.observe(e));

// ── Type selector (donor) ──
window.addEventListener('DOMContentLoaded',()=>{
  document.querySelector('.type-opt') && document.querySelector('.type-opt').classList.add('selected');
  document.querySelector('.type-opt-t') && document.querySelector('.type-opt-t').classList.add('selected');
  loadCounter();
});

// ── COUNTER ──
const STORAGE_KEY = 'eye2live_pledges';
const TODAY_KEY   = 'eye2live_today';
const WEEK_KEY    = 'eye2live_week';
const GOAL = 10000;

function getToday(){ return new Date().toISOString().slice(0,10); }
function getWeek(){
  const d=new Date(), day=d.getDay(), diff=d.getDate()-day+(day===0?-6:1);
  return new Date(d.setDate(diff)).toISOString().slice(0,10);
}

const BASE_COUNT = 5000; // Base pledges already on record

function loadCounter(){
  let extra = parseInt(localStorage.getItem(STORAGE_KEY)||'0');
  let total  = BASE_COUNT + extra;
  let todayData = JSON.parse(localStorage.getItem(TODAY_KEY)||'{"date":"","count":0}');
  let weekData  = JSON.parse(localStorage.getItem(WEEK_KEY) ||'{"week":"","count":0}');

  const todayCount = todayData.date===getToday() ? todayData.count : 0;
  const weekCount  = weekData.week===getWeek()   ? weekData.count  : 0;

  animateCount('main-counter', total);
  animateCount('today-counter', todayCount);
  animateCount('week-counter', weekCount);
  updateProgress(total);
}

function incrementCounter(){
  let extra = parseInt(localStorage.getItem(STORAGE_KEY)||'0') + 1;
  localStorage.setItem(STORAGE_KEY, extra);
  let total = BASE_COUNT + extra;

  // Today
  let todayData = JSON.parse(localStorage.getItem(TODAY_KEY)||'{"date":"","count":0}');
  if(todayData.date !== getToday()) todayData = {date:getToday(), count:0};
  todayData.count++;
  localStorage.setItem(TODAY_KEY, JSON.stringify(todayData));

  // Week
  let weekData = JSON.parse(localStorage.getItem(WEEK_KEY)||'{"week":"","count":0}');
  if(weekData.week !== getWeek()) weekData = {week:getWeek(), count:0};
  weekData.count++;
  localStorage.setItem(WEEK_KEY, JSON.stringify(weekData));

  // Animate
  animateCount('main-counter', total);
  animateCount('today-counter', todayData.count);
  animateCount('week-counter', weekData.count);
  updateProgress(total);

  // Scroll to counter briefly to show
  document.getElementById('counter-section').scrollIntoView({behavior:'smooth', block:'center'});
}

function animateCount(id, target){
  const el = document.getElementById(id);
  if(!el) return;
  const start = parseInt(el.textContent.replace(/,/g,''))||0;
  const duration = 1200;
  const startTime = performance.now();
  function step(now){
    const progress = Math.min((now-startTime)/duration, 1);
    const ease = 1-Math.pow(1-progress, 4);
    el.textContent = Math.floor(start + (target-start)*ease).toLocaleString('en-IN');
    if(progress<1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

function updateProgress(total){
  const pct = Math.min((total/GOAL)*100, 100);
  document.getElementById('progress-bar').style.width = pct+'%';
  document.getElementById('goal-label').textContent = `Goal: ${GOAL.toLocaleString('en-IN')}`;
}

// ── Tab switcher ──
function switchTab(tab){
  const donor=document.getElementById('form-donor');
  const recip=document.getElementById('form-recipient');
  const tDonor=document.getElementById('tab-donor');
  const tRecip=document.getElementById('tab-recipient');
  if(tab==='donor'){
    donor.style.display='block'; recip.style.display='none';
    tDonor.style.cssText='padding:.7rem 2rem;border-radius:100px;border:none;font-family:\'Montserrat\',sans-serif;font-size:1.8rem;font-weight:700;letter-spacing:.06em;cursor:pointer;background:linear-gradient(135deg,#f5a623,#e8633a);color:white;box-shadow:0 4px 16px rgba(245,166,35,.3);transition:all .25s';
    tRecip.style.cssText='padding:.7rem 2rem;border-radius:100px;border:none;font-family:\'Montserrat\',sans-serif;font-size:1.8rem;font-weight:700;letter-spacing:.06em;cursor:pointer;background:transparent;color:#888;transition:all .25s';
  } else {
    recip.style.display='block'; donor.style.display='none';
    tRecip.style.cssText='padding:.7rem 2rem;border-radius:100px;border:none;font-family:\'Montserrat\',sans-serif;font-size:1.8rem;font-weight:700;letter-spacing:.06em;cursor:pointer;background:linear-gradient(135deg,#0f6b6b,#1a9090);color:white;box-shadow:0 4px 16px rgba(15,107,107,.25);transition:all .25s';
    tDonor.style.cssText='padding:.7rem 2rem;border-radius:100px;border:none;font-family:\'Montserrat\',sans-serif;font-size:1.8rem;font-weight:700;letter-spacing:.06em;cursor:pointer;background:transparent;color:#888;transition:all .25s';
  }
}

// ── Tab switcher — 3 tabs ──
function switchTab(tab){
  // panels
  var donor  = document.getElementById('form-donor');
  var recip  = document.getElementById('form-recipient');
  var clinic = document.getElementById('form-clinic');

  // buttons
  var tDonor  = document.getElementById('tab-donor');
  var tRecip  = document.getElementById('tab-recip');
  var tClinic = document.getElementById('tab-clinic');

  // hide all panels
  if(donor)  donor.style.display  = 'none';
  if(recip)  recip.style.display  = 'none';
  if(clinic) clinic.style.display = 'none';

  // reset all buttons
  var btnBase = 'padding:.7rem 2rem;border-radius:100px;border:none;font-family:\'Montserrat\',sans-serif;font-size:1.6rem;font-weight:700;letter-spacing:.06em;cursor:pointer;transition:all .25s;background:transparent;color:#888;box-shadow:none;';
  if(tDonor)  tDonor.style.cssText  = btnBase;
  if(tRecip)  tRecip.style.cssText  = btnBase;
  if(tClinic) tClinic.style.cssText = btnBase;

  // activate selected tab
  if(tab === 'donor'){
    if(donor) donor.style.display = 'block';
    if(tDonor) tDonor.style.cssText = btnBase + 'background:linear-gradient(135deg,#f5a623,#e8633a);color:white;box-shadow:0 4px 16px rgba(245,166,35,.35);';

  } else if(tab === 'recipient'){
    if(recip) recip.style.display = 'block';
    if(tRecip) tRecip.style.cssText = btnBase + 'background:linear-gradient(135deg,#0f6b6b,#1a9090);color:white;box-shadow:0 4px 16px rgba(15,107,107,.3);';

  } else if(tab === 'clinic'){
    if(clinic) clinic.style.display = 'block';
    if(tClinic) tClinic.style.cssText = btnBase + 'background:linear-gradient(135deg,#1a402b,#2d6e4e);color:white;box-shadow:0 4px 16px rgba(26,64,43,.35);';
  }
}

// ── Type selector ──
function selectType(el, form){
  var cls = form === 'donor' ? '.type-opt' : '.type-opt-t';
  document.querySelectorAll(cls).forEach(function(e){ e.classList.remove('selected'); });
  el.classList.add('selected');
}

// ── File preview ──
function showFiles(input){
  var list = document.getElementById('file-list');
  list.innerHTML = '';
  Array.from(input.files).forEach(function(f){
    var size = (f.size/1024/1024).toFixed(2);
    var div  = document.createElement('div');
    div.style.cssText = 'display:flex;align-items:center;gap:.6rem;padding:.6rem 1rem;background:#f8fdfd;border:1px solid #e0f0f0;border-radius:8px;font-size:1.4rem;color:#333';
    div.innerHTML = '<span>📄</span><span style="flex:1;font-weight:500">' + f.name + '</span><span style="color:#000">' + size + ' MB</span>';
    list.appendChild(div);
  });
}

// ── Form submit popup ──
function submitForm(type){
  if(type === 'donor' && typeof incrementCounter === 'function') incrementCounter();

  var msg = type === 'donor'
    ? 'Thank you for your pledge! You are now part of the Eye2Live movement. We will be in touch soon.'
    : 'Thank you for registering. Our team will contact you within 48 hours to guide you through the next steps.';

  var overlay = document.createElement('div');
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem';

  var pledgeLine = '';
  if(type === 'donor' && typeof BASE_COUNT !== 'undefined'){
    var n = (BASE_COUNT + parseInt(localStorage.getItem(typeof STORAGE_KEY !== 'undefined' ? STORAGE_KEY : '_e2l') || '0')).toLocaleString('en-IN');
    pledgeLine = '<p style="font-size:1.6rem;color:#f5a623;font-weight:700;margin-bottom:1.5rem">You are pledge #' + n + ' 🎉</p>';
  }

  var gradColor = type === 'donor' ? '#f5a623,#e8633a' : (type === 'recipient' ? '#0f6b6b,#1a9090' : '#1a402b,#2d6e4e');
  var icon      = type === 'donor' ? '🌟' : '👁';

  overlay.innerHTML = '<div style="background:white;border-radius:24px;padding:3rem 2.5rem;max-width:460px;width:100%;text-align:center;box-shadow:0 24px 60px rgba(0,0,0,.15)">'
    + '<div style="font-size:3.5rem;margin-bottom:1rem">' + icon + '</div>'
    + '<h3 style="font-family:\'Montserrat\',sans-serif;font-size:2.2rem;font-weight:800;color:#111;margin-bottom:.8rem">Submission Received!</h3>'
    + '<p style="font-size:1.6rem;color:#666;line-height:1.75;margin-bottom:1rem">' + msg + '</p>'
    + pledgeLine
    + '<button onclick="this.closest(\'[style*=fixed]\').remove()" style="background:linear-gradient(135deg,' + gradColor + ');color:white;border:none;padding:.85rem 2.2rem;border-radius:100px;font-family:\'Montserrat\',sans-serif;font-weight:700;font-size:1.6rem;cursor:pointer">Done ✓</button>'
    + '</div>';

  document.body.appendChild(overlay);
}

// ── Custom checkbox toggle ──
window.toggleChk = function(id, label){
  var inp = document.getElementById(id);
  var box = document.getElementById('box-' + id);
  if(!inp) return;
  inp.checked = !inp.checked;
  if(box) box.classList[inp.checked ? 'add' : 'remove']('on');
};